import { render, staticRenderFns } from "./AlertEventDialogNotificationTabComponent.vue?vue&type=template&id=5206d6b3&scoped=true"
import script from "./AlertEventDialogNotificationTabComponent.js?vue&type=script&lang=js&external"
export * from "./AlertEventDialogNotificationTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertEventDialogNotificationTabComponent.vue?vue&type=style&index=0&id=5206d6b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206d6b3",
  null
  
)

export default component.exports